var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',{attrs:{"id":"main","role":"main"}},[_c('nuxt')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }